import React , { useState, useEffect }from 'react';
import moment from "moment";
import { Link, useNavigate ,useParams} from "react-router-dom";
import { CardText, Col, Row, Button, Table } from "reactstrap";
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Pagination from "@mui/material/Pagination";
import DateRangePicker from "react-bootstrap-daterangepicker";
import 'bootstrap-daterangepicker/daterangepicker.css';
import Modal from "react-modal";
import { useForm } from "react-hook-form";
import axios from "axios";
import base_url from '../../../api/bootapi';
import { customStyles, useStyles, customStyles2 } from "./../../../Utilities/CSSUtilities";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectEmployee } from "../../../components/features/empSlice";
import Designationicon from "../../../components/images/event.png";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useToasts } from 'react-toast-notifications';
import { toast } from "react-toastify";
import CallAuditapi from "../../services/auditservice";
import close from "../../../components/images/closeicon.png";
import editicon from "../../../components/images/edit.png";
import deleteicon from "../../../components/images/delete.png";

const Designation = () => {
  const classes = useStyles();
  const params = useParams();
  //console.log(params); 
  const jwtToken = "JWT " + localStorage.getItem("JWTToken");
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [designations, setDesignation] = useState([]);
  const [modalCreate, setCreate] = React.useState(false);
  const navigate =useNavigate();
  const [searchdata, setsearch] = useState();
  const [datevalue, setdatevalue] = useState("Click to open");
  const [datefilter, setdatefilter] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [inputtype, setinputtype] = useState("password");
  const employeeData = useSelector(selectEmployee);
  const [pageNo, setPageNo] = useState(1);
  const [paginationPageNo, setPaginationPageNo] = useState(1);
  const [getPageNo, setGetPageNo] = useState();
  const [rows, setRows] = React.useState(50);
  const [sortState, setsortState] = useState("name");
  const [direction, setdirection] = useState("Desc");
  const [totalcount, setTotalCount] = useState();
  const [countNumber, setCountNumber] = useState();
  const [numberOfElements, setNumberOfElements] = useState();
  const [selectedDelete, setSelectedDelete] = useState();
  const [datesrange, setdatesrange] = useState();
  const [display1, setdisplay] = useState("inline");
  const dispatch = useDispatch(); 
  const [permissionObj, setPermissionObj] = useState();
  

  const { addToast } = useToasts();

  const createDesignation = (data2) => {
    setBackdropOpen(true);
    let name  = data2.name;
  
    let data = {
      name,
    };
    axios 
      .post(`${base_url.api1}/myappapi/designation?company_code=` + employeeData.company_code, data, {
        headers: {
          Authorization: jwtToken,
        },
      })
      .then(
        (response) => {
          let log = employeeData.emp_name+" created Designation "+data.name;
          CallAuditapi(log);
          getAllDesignation(pageNo);
          setCreate(false);
          document.getElementById("addform").reset();
          
        },
        (error) => {
          console.log(error);
          document.getElementById("addform").reset();
          setBackdropOpen(false);
          setCreate(false);
        }
      );
  };

  useEffect( () => {
    window.addEventListener("storage", function (e) {
      if (e.key === null) {
        dispatch(logout());
        navigate("/");
      }
    });
    getPermissions();
  },[rows]);
  
  const handleRows = (event) => {
    setRows(event.target.value);
  };
  
    
  const getPermissions = () => {
    const resource_obj = [];

    for (let i = 0; i < employeeData.role_permissions.length; i++) {
      resource_obj.push(employeeData.role_permissions[i].resource_id);
    }
    setPermissionObj(resource_obj);
    // var available_resource44 = resource_obj.includes(44);
    // var available_resource45 = resource_obj.includes(45);
    // var available_resource46 = resource_obj.includes(46);
    // var available_resource47 = resource_obj.includes(47);
    var available_resource81 = resource_obj.includes(81);

    // if(available_resource44 && (available_resource45 || available_resource46 || available_resource47)) {
      if(available_resource81) {
      if (localStorage.getItem("DesignationPageNo")) {
        let currentPage = localStorage.getItem("DesignationPageNo");
        setPageNo(currentPage);
        setPaginationPageNo(Number(currentPage));
        getAllDesignation(currentPage);
      } else {
        setPageNo(1);
        setPaginationPageNo(1);
        getAllDesignation(1);
      }
    } else {
      navigate('/errorPage');
    }
  };

  const [editOpen, setEdit] = React.useState(false);
  const [editDesignationId, seteditDesignationId] = useState();
  const [editDesignationName, seteditDesignationName] = useState();
  const editDesignationData = (elem,designation) => {
    console.log(designation);
    seteditDesignationId(designation.id);
    seteditDesignationName(designation.name);
    setEdit(true);
  };
  const editOldDesignation= () =>{
        setBackdropOpen(true);
        let data = {
          name: editDesignationName.trim(),
        };
        axios
          .put(`${base_url.api1}/myappapi/designation?company_code=`+ employeeData.company_code + `&id=` + editDesignationId  , data, {
            headers: {
              Authorization: jwtToken,
            },
          })
          .then((response) => {
            let log = employeeData.emp_name+" edited in Designation";
            CallAuditapi(log);
            setBackdropOpen(false);
            setEdit(false);
            getAllDesignation(pageNo);
          })
          .catch((error) => {
            setBackdropOpen(false);
          });
      }

  const handleEvent = (event, picker) => {
    console.log(picker.startDate);
  };
    
  const handleCallback = (start, end, label) => {
    console.log(start, end, label);
  };

  const getAllDesignation = (value1) => {
    console.log(value1);
    setBackdropOpen(true);
    axios
      .get(`${base_url.api1}/myappapi/designation_list?company_code=` + employeeData.company_code +`&page=`+ value1 +`&size=`+ rows, {
        headers: {
          Authorization: jwtToken,
        },
      })
      .then(
        (response) => {
          setDesignation(response.data.Designation);
          setGetPageNo(response.data.total_pages);
          setTotalCount(response.data.total_count);
          setCountNumber(value1-1);
          setNumberOfElements(response.data.Designation.length);
          setSelectedDelete([]);
          setsearch(false);
          setBackdropOpen(false);
          document.getElementById("myForm").reset();
        },
        (error) => {
          console.log(JSON.stringify(error.response.data));
          setBackdropOpen(false);
          setDesignation();
        }
      );
  };

  const closedModal = () => {
    setDelete(false);
  }
  const closeModal = () => {
    setCreate(false);
  }

  const createModalDesignation = () => {
    setCreate(true);
  };

  const DeleteInDesignation = () => {
    setDelete(true);
  };

  const [DeleteId, setDeleteId] = useState();
  const [deleteOpen, setDelete] = React.useState(false);
  const deleteDesignation = (elem,designation) => {
    console.log(designation);
    setDeleteId(designation.id);
  };
  const deleteCurrentDesignation = () => {
    axios
      .delete(`${base_url.api1}/myappapi/designation?company_code=` + employeeData.company_code +`&id=` + DeleteId  , {
        headers: {
          Authorization: jwtToken,
        },
      })
      .then(
        (response) => {
          setBackdropOpen(false);
          setDelete(false);
          getAllDesignation(pageNo);
        },
        (error) => {
          setBackdropOpen(false);
          console.log(JSON.stringify(error.response.data));
        }
      );
  };

  const handlepage = (event, value) => {
    setPaginationPageNo(value);
    setPageNo(value);
    if(searchinput!='' || searchinput !=null || searchinput != undefined){
      submitSearchpage(value);
    }else{
      getAllDesignation(value);
    }
    console.log(value);
    
  };


  const [searchinput, setsearchinput] = useState();
  const submitSearch = (e, value) => {
     setdisplay("none");
    setsearch(true);
    let srchdata = e.target[0].value.trim();
    setsearchinput(srchdata);
    console.log(srchdata);
    setBackdropOpen(true);
    axios
      .get(`${base_url.api1}/myappapi/designation_list?company_code=`+ employeeData.company_code+ `&page=`+ value +`&size=` + rows +`&search=`+srchdata, {
        headers: {
          Authorization: jwtToken,
        },
      })
      .then(
        (response) => {
          setDesignation(response.data.Designation);
          console.log(response.data.Designation);
          setGetPageNo(response.data.total_pages);
          setNumberOfElements(response.data.Designation.length);
          setTotalCount(response.data.total_count);
          setBackdropOpen(false);
        },
        (error) => {
          console.log(JSON.stringify(error.response.data));
          setDesignation();
          setBackdropOpen(false);
        },
        (error) => {
          console.log(JSON.stringify(error.response.data));
        }
      );
  };

  const submitSearchpage = ( value) => {
    setdisplay("none");
   setsearch(true);
   setBackdropOpen(true);
   axios
     .get(`${base_url.api1}/myappapi/designation_list?company_code=`+ employeeData.company_code+ `&page=`+ value +`&size=` + rows +`&search=`+searchinput, {
       headers: {
         Authorization: jwtToken,
       },
     })
     .then(
       (response) => {
         setDesignation(response.data.Designation);
         console.log(response.data.Designation);
         setGetPageNo(response.data.total_pages);
         setNumberOfElements(response.data.Designation.length);
         setTotalCount(response.data.total_count);
         setBackdropOpen(false);
       },
       (error) => {
         console.log(JSON.stringify(error.response.data));
         setDesignation();
         setBackdropOpen(false);
       },
       (error) => {
         console.log(JSON.stringify(error.response.data));
       }
     );
 };



  const sortUser = (e) => {
    setsortState(e.target.id);
    console.log();
    if (direction == "Desc") {
      setdirection("ASC");
    } else if (direction == "ASC") {
      setdirection("Desc");
    }
    let sortby = e.target.id

    axios
      .get(`${base_url.api1}/myappapi/designation_list?company_code=` + employeeData.company_code + `&sortby=`+sortby+`&Order=`+direction +`&page=`+pageNo, {
        headers: {
          Authorization: jwtToken,
        },
      })
      .then(
        (response) => {
          setDesignation(response.data.Designation);
          document.getElementById("myForm").reset();
          setGetPageNo(response.data.total_pages);
          //console.log(response.data.total_pages);
          setTotalCount(response.data.total_count);
          setCountNumber(pageNo-1);
          setNumberOfElements(response.data.Designation.length);
          //console.log(response.data.Users.length);
          setSelectedDelete([]);
          setsearch(false);
          setBackdropOpen(false);
        },
        (error) => {
          console.log(JSON.stringify(error.response.data));
          setDesignation();
        }
      );
  };
  const handleApply = (event, picker) => {
    setBackdropOpen(true);
    setdatevalue(
      `${picker.startDate.format("DD-MM-YYYY")} to ${picker.endDate.format(
        "DD-MM-YYYY"
      )}`
    );
    setPageNo(0);
    setPaginationPageNo(1);
    let data = {
      from: picker.startDate.format("MM-DD"),
      to: picker.endDate.format("MM-DD"),
      //sortby: sortState,
     // Order: direction,
    };
    setdatesrange(data);
    axios
      .get(`${base_url.api1}/myappapi/designation_list?company_code=` + employeeData.company_code +`&from=`+data.from+`&to=`+data.to, {
        headers: {
          Authorization: jwtToken,
        },
      })
      .then(
        (response) => {
          setDesignation(response.data.Designation);
          setGetPageNo(response.data.total_pages);
          setNumberOfElements(response.data.Designation.length);
          setTotalCount(response.data.total_count);
          setsearch(false);
          setBackdropOpen(false);
          setdatefilter(true);
          document.getElementById("myForm").reset();
          setSelectedDelete([]);
          document.getElementById("myForm").reset();
        },
        (error) => {
          setDesignation();
          console.log(JSON.stringify(error.response.data));
          setdatefilter(true);
          setBackdropOpen(false);
        }
      );
  };
  
  return (
    <div>
      <Backdrop open={backdropOpen}
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="commoncomponent_cardcss">
        <div style={{ margin: "5px" ,marginTop: "-30px"}}>
          <Row>
            {/* <Col md={6}>
              <CardText
                className={classes.headtext}
                style={{ marginTop: "-10px" }}
              >
                <h2>Designation List</h2>
              </CardText>
            </Col>
            <Col md={6}  className="d-flex justify-content-end">
              {permissionObj?.includes(45)?
                <Button
                  color="primary"
                  onClick={createModalDesignation}
                >
                  + Add
                </Button>
              :null}
            </Col> */}
         {permissionObj?.includes(45)?
        <div className="newhead">
          <h4>Designation List</h4>
          <div onClick={createModalDesignation}>
            <h6>New</h6> <p>+</p>
          </div>
        </div> :null}

            <Modal
              ariaHideApp={false}
              isOpen={modalCreate}
              onRequestClose={closedModal}
              style={customStyles}
              contentLabel="Example Modal"
            >
          <div style={{ textAlign: "right", padding: "10px 20px" }}>
            <img className="closei" src={close} onClick={() =>setCreate(false)} />
          </div>
          <div className='modalContainer'>
            <div style={{ textAlign: "center" }}>
              <img className='modelIcon' src={Designationicon} />
            </div>
              <form onSubmit={handleSubmit(createDesignation)} id="addform">
               <h1>Create Designation</h1>
                <div>
                  <div style={{ marginTop: "20px" }}>

                    <h3 >Designation Name<span >*</span></h3>
                        <input
                          type="text"
                          className='modalinput'
                          placeholder="Designation Name"
                          id="name"
                          {...register("name",{ required: true })}
                        />
                        {errors.name && (
                          <p className="errormessage">Designation Name is Required</p>
                        )}
                  </div>

                          <div style={{ display: "flex", justifyContent: "space-between", margin: "30px 0px" }}>
                          <button className='modalbtn backbtn' onClick={() => setCreate(false)}>Back</button>
                          <button className='modalbtn submitbtn' >Submit</button>
                          </div>
                 
                </div>
              </form>
              <div>
             </div> 
              <br />
            </div>
           </Modal>
          </Row>
          <div className="newlisting_headertabdesign">
          <Row>
            <form className="master">
                  <div style={{ marginTop: "15px" }}>
                    <label className="area_rowslable">Limit</label>
                    <br />
                    <FormControl className={classes.formControl}>
                      <Select
                        className={classes.selectlimit}
                        labelId="simple-select-label"
                        id="simple-select"
                        value={rows}
                        onChange={handleRows}
                      >
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </form>
                <br/>

              <br/>
              <Col md={0}>
                <div className="form-group">
                  <div>
                    <div className="clearsearchclass">
                      <form
                        id="myForm"
                        className="d-flex"
                        onSubmit={(e) => {
                          e.preventDefault();
                          submitSearch(e,1);
                      }}
                      >
                        <input
                          style={{
                            padding: "5px",
                            border: "2px solid",
                            marginTop: "-1px",
                          }}
                          className="form-control"
                          placeholder="Search.."
                          name="search"
                          required
                        />
                        <button
                          color="blue"
                          className={classes.srchbtn}
                          type="submit"
                        >
                          <i className="fa fa-search"></i>
                        </button>
                      </form>
                      {searchdata ? (
                        <a    
                        onClick={() => {
                            setdisplay("inline");
                            setBackdropOpen(true);
                            setPageNo(1);
                            getAllDesignation(1);
                            setsearchinput();
                            setdatefilter(false);
                          }}                      
                        >
                          Clear Search
                        </a>
                      ) : null}
                    </div>                      
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="newlisting_headertabdesign">
            <Table responsive striped>
            <thead>
                <tr>
                  <th>SNo.</th>
                  <th style={{ textAlign: "center" }}>
                    Designation Name{" "}
                    <UnfoldMoreIcon onClick={sortUser} id="name"/>
                  </th>
                  <th style={{ textAlign: "center", width: "175px" }}>Action</th>
                </tr>
              </thead>              
              <tbody>
                {designations != null ? (
                  designations &&
                  designations.map((designation , index) => (
                  <tr>
                    <th>{countNumber * rows + 1 + index}</th>
                    <td style={{ textAlign: "center" }}>{designation.name}</td> 
                    <td>
                      <div style={{
                          position: "relative",
                          textAlign: "center",
                        }}
                      >
                        <div
                          className="workflowdashboard_fa-ellipsis"
                          data-toggle="dropdown"
                        >
                          <i
                            className="fa fa-ellipsis-v "
                            aria-hidden="true"
                          ></i>
                        </div>
                        <div
                          className="dropdown-menu workflowdashboarddropdown"
                          style={{ width: "200px" }}
                        >
                          {permissionObj?.includes(46)?
                            <p id={designation.id}
                              onClick={(e)=>{
                                e.preventDefault();
                                editDesignationData(e, designation)}}>
                              Edit
                            </p>
                          :null}
                          <Modal
                            isOpen={editOpen}
                            onRequestClose={closeModal}
                            style={customStyles}
                            ariaHideApp={false}
                            contentLabel="Example Modal"
                          >

                          <div style={{ textAlign: "right", padding: "10px 20px" }}>
                            <img className="closei" src={close} onClick={() => setEdit(false)} />
                          </div>
                          <div className='modalContainer'>
                            <div style={{ textAlign: "center" }}>
                              <img className='modelIcon' src={editicon} />
                            </div>
                            <h1>Edit Designation</h1>  
                            <form id="editForm" onSubmit={(e) => {
                                e.preventDefault();
                                editOldDesignation(e);
                              }}>
                              <div>
                                <div style={{ marginTop: "20px" }}>
                                <h3 >Designation Name<span >*</span></h3>
                                      <input
                                        type="text"
                                        className="modalinput"
                                        value={editDesignationName}
                                        onChange={(e) => {
                                          seteditDesignationName(e.target.value);
                                        }}
                                        required
                                      />
                                </div>  
                              
                              <div style={{ display: "flex", justifyContent: "space-between", margin: "30px 0px" }}>
                                <button className='modalbtn backbtn' onClick={() => setEdit(false)}>Back</button>
                                <button className='modalbtn submitbtn' >Submit</button>
                              </div>
                              </div>
                            </form>
                            </div>                
                          </Modal>
                          {permissionObj?.includes(47)?
                            <p
                              id={designation.id}
                              onClick={(e) => {
                                deleteDesignation(e, designation);
                                DeleteInDesignation();
                              }} color="danger">Delete
                            </p>                          
                          :null}
                         
                          <Modal
                            ariaHideApp={false}
                            isOpen={deleteOpen}
                            onRequestClose={closedModal}
                            style={customStyles2}
                            contentLabel="Example Modal"
                          >
                            <h5>
                              Are you sure you want to delete current record ?
                            </h5>
                            <div style={{ float: "right" }}>
                              <Button
                                color="danger"
                                type="submit"
                                onClick={deleteCurrentDesignation}
                              >
                                Delete
                              </Button>
                              &nbsp;&nbsp;&nbsp;
                              <Button
                                color="secondary"
                                onClick={() => setDelete(false)}
                              >
                                Cancel
                              </Button>
                            </div>
                          </Modal> 
                        </div>
                      </div>
                    </td>
                  </tr>
                ))) : (
                  <p className={classes.headertekst}>{null}</p>
                )}
              </tbody>
            </Table>
            <div>
            <Row>
            <Col md={6}>
              {designations?.length ? (
                <p style={{ marginTop: "15px" }}>
                  {countNumber * rows + 1} to{" "}
                  {countNumber * rows + numberOfElements} of {totalcount} records
                </p>
              ) : (
                <p className="formfooterrecordstyle">No Record Found</p>
              )}
            </Col>
            <Col md={6}>
              <div className={classes.root}>
                {searchdata || datefilter ? (
                  <Pagination
                    page={paginationPageNo}
                    count={getPageNo}
                    onChange={submitSearch}
                  />
                ) : (
                  <Pagination
                    page={paginationPageNo}
                    count={getPageNo}
                    onChange={handlepage}
                  />
                 )}
              </div>
            </Col>
          </Row>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Designation